<template>
  <d-page-layout :hasSearch="false">
    <template slot="heading">
      <v-breadcrumbs class="pa-0" :items="items"></v-breadcrumbs>
    </template>
    <template slot="actions">
      <v-btn
        color="primary"
        depressed
        class="ml-2"
        @click="addOrEditModal = true"
      >
        <v-icon left> mdi-plus </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("defaults.button.create")
        }}</span>
      </v-btn>
    </template>
    <template slot="content">
      <d-loading class="mb-4" v-if="loading"></d-loading>
      <template v-else>
        <v-row>
          <v-col cols="12" md="4" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("projects.add.form.name") }}:
            </h6>
            <p class="mb-0">{{ project.name }}</p>
          </v-col>

          <v-col cols="12" md="4" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("projects.add.form.slug") }}:
            </h6>
            <p class="mb-0">{{ project.slug }}</p>
          </v-col>

          <v-col cols="12" md="4" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("projects.add.form.base-url") }}:
            </h6>
            <p class="mb-0">{{ project.baseUrl }}</p>
          </v-col>

          <v-col cols="12" class="mb-3">
            <h6 class="subtitle-1 font-weight-bold gray--text text--darken-2">
              {{ $t("projects.add.form.description") }}:
            </h6>
            <p class="mb-0">{{ project.description }}</p>
          </v-col>
        </v-row>
        <List
          :projectId="project?.id"
          @edit="handleEdit"
          @changeStatus="handleChangeStatus"
        ></List>
        <AddOrEditModal
          v-if="addOrEditModal"
          :modal="addOrEditModal"
          :item="selectedItem"
          :projectBaseUrl="project.baseUrl"
          @closeModal="handleCloseAddOrEditModal"
          @submitModal="handleSubmitAddOrEditModal"
        ></AddOrEditModal>
        <ChangeStatusModal
          v-if="changeStatusModal"
          :modal="changeStatusModal"
          :item="selectedItem"
          @closeModal="handleCloseChangeStatusModal"
          @submitModal="handleSubmitChangeStatusModal"
        >
        </ChangeStatusModal>
      </template>
    </template>
  </d-page-layout>
</template>
<script>
import List from "./List.vue";
import AddOrEditModal from "./AddOrEditModal.vue";
import ChangeStatusModal from "./ChangeStatusModal.vue";
import { getProjectById } from "@/services/project";

export default {
  components: {
    List,
    AddOrEditModal,
    ChangeStatusModal,
  },
  data: (vm) => ({
    items: [
      {
        text: vm.$t("projects.page-heading"),
        disabled: false,
        to: "/projects",
      },
      {
        text: "",
        disabled: true,
      },
      {
        text: vm.$t("project-apis.text.apis"),
        disabled: true,
      },
    ],
    project: null,
    addOrEditModal: false,
    changeStatusModal: false,
    selectedItem: null,
    loading: true,
  }),
  methods: {
    handleEdit(item) {
      this.selectedItem = item;
      this.addOrEditModal = true;
    },
    handleSubmitAddOrEditModal() {
      this.$eventBus.$emit("fetchProjectApis");
      this.handleCloseAddOrEditModal();
    },
    handleCloseAddOrEditModal() {
      this.selectedItem = null;
      this.addOrEditModal = false;
    },
    handleChangeStatus(item) {
      this.selectedItem = item;
      this.changeStatusModal = true;
    },
    handleSubmitChangeStatusModal() {
      this.$eventBus.$emit("fetchProjectApis");
      this.handleCloseChangeStatusModal();
    },
    handleCloseChangeStatusModal() {
      this.selectedItem = null;
      this.changeStatusModal = false;
    },
  },
  async created() {
    try {
      this.loading = true;
      this.project = await getProjectById(this.$route.params.id).then(
        (res) => res.data
      );
      this.$eventBus.$emit("fetchProjectApis");
      this.items[1].text = this.project?.name;
    } finally {
      this.loading = false;
    }
  },
};
</script>
